var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: {
        title: "Edit personal information",
        label: "Update",
        disabled: _vm.isDisabledSubmit
      },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        },
        "backdrop-action": _vm.onSave
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "grid items-center grid-cols-6 gap-4 px-8 overflow-y-auto",
          style: { width: "48rem", maxHeight: "calc(100vh - 14rem)" }
        },
        [
          _c("BlInputText", {
            staticClass: "col-span-6",
            attrs: { input: _vm.nameInput },
            on: { changed: _vm.inputHandler }
          }),
          _vm._v(" "),
          _c("BlInputDate", {
            staticClass: "col-span-3",
            attrs: { input: _vm.dateOfBirthInput },
            on: { changed: _vm.inputHandler }
          }),
          _vm._v(" "),
          _c("BlSelectBox", {
            staticClass: "col-span-3",
            attrs: {
              label: "Status",
              asterisk: "",
              placeholder: "Select status",
              options: _vm.statusOptions
            },
            on: {
              change: function($event) {
                _vm.statusInput = $event
              }
            },
            model: {
              value: _vm.statusInput,
              callback: function($$v) {
                _vm.statusInput = $$v
              },
              expression: "statusInput"
            }
          }),
          _vm._v(" "),
          _c("BlInputDate", {
            staticClass: "col-span-3",
            attrs: { input: _vm.dateAdmittedInput },
            on: { changed: _vm.inputHandler }
          }),
          _vm._v(" "),
          _c("BlInputDate", {
            staticClass: "flex-grow col-span-3",
            attrs: { input: _vm.dateOfDischargeInput },
            on: { changed: _vm.inputHandler }
          }),
          _vm._v(" "),
          _vm.enableSalesPipeline
            ? _c(
                "div",
                { staticClass: "flex flex-col col-span-6 gap-1" },
                [
                  _c("BlSelectBox", {
                    attrs: {
                      label: "Discharge reason",
                      asterisk: _vm.dischargeReasonInput.asterisk,
                      disabled: _vm.dischargeReasonInput.disabled,
                      placeholder: "Select discharge reason",
                      options: _vm.dischargeReasonOptions
                    },
                    on: {
                      change: function($event) {
                        _vm.dischargeReasonInput.model = $event
                      }
                    },
                    model: {
                      value: _vm.dischargeReasonInput.model,
                      callback: function($$v) {
                        _vm.$set(_vm.dischargeReasonInput, "model", $$v)
                      },
                      expression: "dischargeReasonInput.model"
                    }
                  }),
                  _vm._v(" "),
                  _vm.dischargeReasonInput.model === "other"
                    ? _c("BlInputText", {
                        attrs: { input: _vm.otherDischargeReasonInput },
                        on: { changed: _vm.inputHandler }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("BlSelectBox", {
            staticClass: "col-span-3",
            attrs: {
              label: "Gender",
              placeholder: "Select gender",
              options: _vm.genderOptions
            },
            on: {
              change: function($event) {
                _vm.genderInput = $event
              }
            },
            model: {
              value: _vm.genderInput,
              callback: function($$v) {
                _vm.genderInput = $$v
              },
              expression: "genderInput"
            }
          }),
          _vm._v(" "),
          _c("BlInputText", {
            staticClass: "col-span-3",
            attrs: { input: _vm.emailInput },
            on: { changed: _vm.inputHandler }
          }),
          _vm._v(" "),
          _c("BlInputText", {
            staticClass: "col-span-6",
            attrs: { input: _vm.noteInput },
            on: { changed: _vm.inputHandler }
          }),
          _vm._v(" "),
          _vm.enableBranch
            ? _c("BlSearchBox", {
                staticClass: "col-span-6",
                attrs: {
                  type: "branch",
                  label: "Branch Tags",
                  drop: "up",
                  placeholder: "Type tag",
                  options: _vm.branchOptions
                },
                on: {
                  change: function($event) {
                    _vm.branchesInput = $event
                  }
                },
                model: {
                  value: _vm.branchesInput,
                  callback: function($$v) {
                    _vm.branchesInput = $$v
                  },
                  expression: "branchesInput"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("BlSearchBox", {
            staticClass: "col-span-6",
            attrs: {
              label: "Client tags",
              drop: "up",
              placeholder: "Type tag",
              options: _vm.labels.map(function(i) {
                return { value: i.id, label: i.name }
              })
            },
            on: {
              change: function($event) {
                _vm.tagsInput = $event
              }
            },
            model: {
              value: _vm.tagsInput,
              callback: function($$v) {
                _vm.tagsInput = $$v
              },
              expression: "tagsInput"
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-166ab04e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-166ab04e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/about/EditClientAboutModal.vue
// module id = null
// module chunks = 